import * as PropTypes from 'prop-types';
import * as React from 'react';
import { isForwardRef } from 'react-is';
import RefFindNode from './RefFindNode';
import RefForward from './RefForward';
var Ref = function (props) {
    var children = props.children, innerRef = props.innerRef;
    var child = React.Children.only(children);
    var ElementType = isForwardRef(child) ? RefForward : RefFindNode;
    return React.createElement(ElementType, { innerRef: innerRef }, child);
};
Ref.propTypes = {
    children: PropTypes.element.isRequired,
    innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};
export default Ref;
